import React, { FC, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Formik, Field, Form, ErrorMessage } from "formik";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import ConfirmationModal from "../shared/ConfirmationModal";
import NewconfirmationModal from "../shared/NewconfirmationModal";
import AllFailureModal from "../shared/AllFailureModal";
import { values } from "lodash";

const TestimonialAdd: FC = () => {
  const navigate = useNavigate();
  const [modalShow, setModalShow] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const [status, setStatus] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [showFailureModal, setShowFailureModal] = useState(false);
  const [failureMessage, setFailureMessage] = useState("");
  // const [pendingSubmitData, setPendingSubmitData] = useState(null);
  const [pendingAction, setPendingAction] = useState<(() => void) | null>(null);

  
  const callApiAddTestimonial = async (values: any, resetForm: any) => {
    setModalMessage("Are you sure you want to add this testimonial?");
    setPendingAction(() => async () => {
      try {
        const url = `${process.env.REACT_APP_API_URL}testimonials/add`;
        const imageFile = (document.getElementById("author_image") as HTMLInputElement).files?.[0] || null;
        const formData = new FormData();
  
        formData.append("author_name", values.author_name);
        formData.append("author_designation", values.author_designation);
        formData.append("testimonial_text", values.testimonial_text);
        formData.append("rating", values.rating);
  
        if (imageFile) {
          formData.append("author_image", imageFile);
        }
  
        const token = localStorage.getItem("jwttoken") || "";

  
        const response = await axios.post(url, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            "x-access-token": token,
          },
        });
        if (response.status === 201) {
          setSuccessMessage("Testimonial added successfully.");
          setShowSuccessModal(true);
          setTimeout(() => {
            setShowSuccessModal(false);
            navigate('/testimonials');
          }, 3000);
        }
      } catch (error: any) {
        console.error("API call failed:", error);
        setFailureMessage(error.response?.data?.message || "Failed to add testimonial.");
        setShowFailureModal(true);
      }
    });
    setModalShow(true); 
  };
  
  const handleModalOk = async () => {
    setModalShow(false);
    if (pendingAction) {
      await pendingAction(); 
    }
  };
  

  return (
    <Container className="mt-5">
      <Row className="justify-content-center">
        <Col md={8}>
          <Card className="shadow">
            <Card.Header className="bg-info text-white text-center">
              <h4>Add New Testimonial</h4>
            </Card.Header>
            <Card.Body>
              <Formik
                initialValues={{
                  author_name: "",
                  author_designation: "",
                  testimonial_text: "",
                  rating: "",
                }}
                onSubmit={async (values, { resetForm }) => {
                  const imageFile = (document.getElementById("author_image") as HTMLInputElement).files?.[0] || null;
                  await callApiAddTestimonial(values, imageFile);
                  resetForm();
                }}
              >
                {({ setFieldValue }) => (
                  <Form>
                    <Row className="mb-3">
                      <Col md={6}>
                        <label htmlFor="author_name" className="form-label">
                          Author Name:
                        </label>
                        <Field name="author_name" type="text" className="form-control" placeholder="Enter Name" required />
                      </Col>

                      <Col md={6}>
                        <label htmlFor="author_designation" className="form-label">
                          Designation:
                        </label>
                        <Field name="author_designation" type="text" className="form-control" placeholder="Enter Designation" required />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Col md={12}>
                        <label htmlFor="testimonial_text" className="form-label">
                          Testimonial:
                        </label>
                        <Field as="textarea" name="testimonial_text" className="form-control" placeholder="Enter Testimonial" required />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Col md={6}>
                        <label htmlFor="rating" className="form-label">
                          Rating (1-5):
                        </label>
                        <Field name="rating" type="number" min="1" max="5" className="form-control" required />
                      </Col>

                      <Col md={6}>
                        <label htmlFor="author_image" className="form-label">
                          Author Image:
                        </label>
                        <input
                          id="author_image"
                          name="author_image"
                          type="file"
                          className="form-control"
                          accept="image/*"
                          onChange={(event) => setFieldValue("author_image", event.currentTarget.files?.[0] || null)}
                        />
                      </Col>
                    </Row>

                    <Row className="mt-4">
                      <Col className="text-center">
                        <Button type="submit" variant="success">
                          Add Testimonial
                        </Button>

                        <Button variant="danger" className="mx-2" onClick={() => navigate("/testimonials")}>
                          Go Back
                        </Button>
                      </Col>
                    </Row>
                  </Form>
                )}
              </Formik>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      {/* Confirmation Modal */}
      <ConfirmationModal 
        show={modalShow} 
        modalMessage={modalMessage} 
        // onHide={handleModalOk}
        onHide={() => setModalShow(false)} confirmation={handleModalOk}
        operationType="Confirm" 
      />

      
      <NewconfirmationModal 
        show={showSuccessModal} 
        onHide={() => setShowSuccessModal(false)} 
        modalMessage={successMessage} 
        operationType="Ok" 
        timeoutDuration={3000} 
      />
      
      <AllFailureModal 
        show={showFailureModal} 
        onHide={() => setShowFailureModal(false)} 
        modalMessage={failureMessage}  
        operationType="Ok" 
        timeoutDuration={5000}
      />
    </Container>
  );
};

export default TestimonialAdd;
